module.exports = __webpack_public_path__ + "img/rewards_ch.e5dc4baa.png";